import React from 'react';

const Upload = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 12.6666V16.2222C17 17.204 16.2041 18 15.2222 18H2.77778C1.79594 18 1 17.204 1 16.2222V12.6666"
      stroke="#3448FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13.4446 6.44444L9.00011 2L4.55566 6.44444"
      stroke="#3448FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9.00011 2V12.6667"
      stroke="#3448FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default Upload;
